"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClientIpHeader = exports.getInitials = exports.uuidToBackground = exports.uuidToInt = exports.debounce = exports.reorderList = exports.getCsrfTokenHeader = exports.formatLocation = exports.getControlId = exports.dateToHumanMonthAndYear = exports.dateToHumanTimeAndDate = exports.dateToMonthAndYearNumeric = exports.dateToMonthAndYear = exports.getYearDropdownOptions = exports.getYears = exports.monthToIndex = exports.getMonths = void 0;
const constants_1 = require("./constants");
/**
 * Return a list of months in order
 */
const getMonths = () => {
    return Array(12)
        .fill('')
        .map((_n, i) => new Date(2000, i).toLocaleString('en-US', { month: 'long' }));
};
exports.getMonths = getMonths;
/**
 * Convert a month name to it's 1-based index
 */
const monthToIndex = (month) => {
    const months = (0, exports.getMonths)();
    for (let i = 0; i < months.length; i++) {
        if (months[i] === month) {
            const monthIndex = `${i + 1}`;
            return monthIndex.length === 1 ? `0${monthIndex}` : `${monthIndex}`;
        }
    }
    return '';
};
exports.monthToIndex = monthToIndex;
/**
 * Return a list of previous years, including the current year
 * ex, [2021, 2020, 2019 ...]
 *
 * @param {number} currentYear ex. 2021
 * @param {number} count how many previous years
 */
const getYears = (currentYear = new Date().getFullYear(), count = 20) => {
    const ret = [];
    for (let i = currentYear; i > currentYear - count; i--) {
        ret.push(i);
    }
    return ret;
};
exports.getYears = getYears;
const getYearDropdownOptions = (allowFuture = false) => {
    return allowFuture
        ? (0, exports.getYears)(new Date().getFullYear() + 10, 111)
        : (0, exports.getYears)(new Date().getFullYear(), 101);
};
exports.getYearDropdownOptions = getYearDropdownOptions;
// Ex. 'Mar 2022'
const dateToMonthAndYear = (dateString, longMonth = false) => {
    const ret = new Date(dateString);
    // Handle Invalid Date
    if (isNaN(ret.getTime())) {
        return '';
    }
    return ret.toLocaleDateString('en-US', {
        month: longMonth ? 'long' : 'short',
        year: 'numeric',
        timeZone: 'UTC',
    });
};
exports.dateToMonthAndYear = dateToMonthAndYear;
// Ex. '03/2022'
const dateToMonthAndYearNumeric = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
        month: '2-digit',
        year: 'numeric',
        timeZone: 'UTC',
    });
};
exports.dateToMonthAndYearNumeric = dateToMonthAndYearNumeric;
// Ex. '10:31 AM EDT on March 14, 2022'
const dateToHumanTimeAndDate = (dateString) => {
    const date = new Date(dateString).toLocaleDateString('en-US', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        timeZone: 'UTC',
    });
    const time = new Date(dateString).toLocaleTimeString('en-US', {
        timeZoneName: 'short',
        hour: 'numeric',
        minute: '2-digit',
    });
    return `${time} on ${date}`;
};
exports.dateToHumanTimeAndDate = dateToHumanTimeAndDate;
//March 23, 2022, Mar 23, 2022
const dateToHumanMonthAndYear = (dateString, longMonth = false) => {
    return new Date(dateString).toLocaleDateString('en-US', {
        month: longMonth ? 'long' : 'short',
        day: '2-digit',
        year: 'numeric',
        timeZone: 'UTC',
    });
};
exports.dateToHumanMonthAndYear = dateToHumanMonthAndYear;
/**
 * Control ID logic
 */
const controlIdMap = {
    link: 'lnk',
    button: 'btn',
    checkbox: 'chk',
    color: 'col',
    date: 'dat',
    email: 'eml',
    file: 'fil',
    hidden: 'hid',
    image: 'img',
    month: 'mon',
    number: 'num',
    password: 'pas',
    radio: 'rad',
    range: 'ran',
    reset: 'res',
    search: 'sea',
    submit: 'sub',
    select: 'sel',
    tel: 'tel',
    text: 'txt',
    time: 'tme',
    url: 'url',
    week: 'wek',
};
const getControlId = ({ type, name } = {}) => {
    const returnType = type && controlIdMap[type] ? controlIdMap[type] : 'id';
    const returnName = name ? name : '';
    const delimiter = returnName ? '-' : '';
    return `${returnType}${delimiter}${returnName}`;
};
exports.getControlId = getControlId;
/**
 * Format location with optional values, could be expanded to support additional formats
 */
function formatLocation({ address1, address2, address3, city, state, country, postalCode, }) {
    const address = [address1, address2, address3].filter((n) => Boolean(n)).join(' ');
    return ([address, city, state, country].filter((n) => Boolean(n)).join(', ') +
        (postalCode ? ` ${postalCode}` : ''));
}
exports.formatLocation = formatLocation;
/**
 * CSRF
 */
const getCsrfTokenHeader = (headers) => {
    const ret = {};
    const key = headers.get('x-ctv-ck');
    const val = headers.get('x-ctv-cv');
    if (!key || !val) {
        return;
    }
    ret[key] = val;
    return ret;
};
exports.getCsrfTokenHeader = getCsrfTokenHeader;
const reorderList = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};
exports.reorderList = reorderList;
const debounce = (func, timeout = 300) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    };
};
exports.debounce = debounce;
const uuidToInt = (uuid) => {
    const parsed = `${parseInt(uuid.replace('-', ''), 16)}`;
    return parseInt(parsed.substring(parsed.length - 1), 10);
};
exports.uuidToInt = uuidToInt;
const uuidToBackground = (uuid) => {
    const id = (0, exports.uuidToInt)(uuid);
    const defaultBgColors = [
        'linear-gradient(135deg, #2D9CDB 0%, #2F80ED 100%)',
        'linear-gradient(315deg, #481EF5 0%, #7B61FF 100%)',
        'radial-gradient(100% 100% at 50% 0%, #FFBA82 0%, #FF8B2D 100%)',
        'linear-gradient(315deg, #F0BB00 0%, #FFEA00 100%)',
        'linear-gradient(315deg, #009288 0%, #29CDA5 100%)',
    ];
    const colorMap = [0, 1, 2, 3, 4, 0, 1, 2, 3, 4];
    return defaultBgColors[colorMap[id]];
};
exports.uuidToBackground = uuidToBackground;
const getInitials = (firstName = '', lastName = '') => {
    return `${firstName.substring(0, 1).toUpperCase()}${lastName.substring(0, 1).toUpperCase()}`;
};
exports.getInitials = getInitials;
// CTV-2528 Convert client IP address header from cloudfront to our custom header for use in server -> server GraphQL calls
const getClientIpHeader = (incomingHeaders) => {
    const ret = {};
    ret[constants_1.CLIENT_IP_HEADER_KEY] = incomingHeaders[constants_1.CLOUDFRONT_IP_HEADER_KEY];
    return ret;
};
exports.getClientIpHeader = getClientIpHeader;
//# sourceMappingURL=data:application/json;base64,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